<template lang="html">
  <!-- Trial -->
  <b-row v-if="limitApproaching" class="mb-5">
    <b-col v-if="limitMet">
      <div class="alert alert-info col-10 offset-1 mt-3">
        <b-row>
          <b-col md="8">
            <h5 class="mt-2">
              You're reached the show limit ({{ slideshowTotal }}/{{
                $store.state.user_plan.show_limit
              }}) for your account.
            </h5>
            <p class="mt-3">
              Please remove a show, or consider upgrading to a higher tier
              account.
            </p>
          </b-col>
          <b-col class="text-right">
            <b-btn
              size="md"
              variant="primary"
              :to="{ name: 'upgrade_view', params: {} }"
            >
              See upgrade options
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-col>
    <b-col v-else>
      <!-- Approaching limit -->
      <div class="alert alert-info col-10 offset-1 mt-3">
        <b-row>
          <b-col>
            Only {{ numberUntilLimit }}
            {{ "show" | pluralize(numberUntilLimit) }} remaining at your current
            tier. ({{ slideshowTotal }}/{{ $store.state.user_plan.show_limit }})
          </b-col>
          <b-col class="text-right">
            <b-btn
              size="md"
              variant="primary"
              :to="{ name: 'upgrade_view', params: {} }"
            >
              See upgrade options
            </b-btn>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "UpgradeMessage",
  filters: {
    pluralize(word, amount) {
      if (amount > 1) {
        return `${word}s`;
      }
      return word;
    }
  },
  computed: {
    limitMet() {
      if ("limit" in this.$route.query) {
        return true;
      }
      return this.$store.getters.trialShowLimitReached;
    },
    limitApproaching() {
      if ("limit" in this.$route.query || "near" in this.$route.query) {
        return true;
      }
      return this.$store.getters.limitApproaching;
    },
    slideshowTotal() {
      return this.$store.getters.slideshowTotal;
    },
    numberUntilLimit() {
      return this.$store.state.user_plan.show_limit - this.slideshowTotal;
    }
  }
};
</script>

<style lang="css" scoped></style>
